import { Injectable } from '@angular/core';
import { ParameterBag } from './parameter-bag';

@Injectable({
    providedIn: 'root'
})
export class UrlFormatter {
    public query: ParameterBag = new ParameterBag();

    public createUrl(url: string): string {
        return `${url}${this.createQueryString(this.query.all())}`;
    }

    /**
     * create the query string part from parameters
     *
     * @example
     * param1=1&param2=2&param3=3
     *
     * @param params
     */
    public createQueryString(params: any = {}): string {
        return `?${Object.keys(params).map((key) => key + '=' + params[key]).join('&')}`;
    }

    /**
     * Returns query string parameters from query string
     *
     * @param url
     */
    public getQueryStringParams(url: string): Object {
        const hashes = url.slice(url.indexOf('?') + 1).split('&');
        const params:any = {};

        hashes.map((hash) => {
            const [key, val] = hash.split('=');
            params[key] = decodeURIComponent(val);
        });

        return params;
    }
}
